<script>
export default {
  functional: true,
  render (h, { props }) {
    return [props.content]
  },
}
</script>
